import React, { useContext, useEffect } from 'react';
import { Link } from 'gatsby';
import Image from 'gatsby-image';
import { useLingui } from '@lingui/react';
import './card.scss';
import Icon from '../icon/icon';
import likesContext from '../../../../contexts/likes-context';

var Card = function Card(_ref) {
  var item = _ref.item,
      place = _ref.place;

  var _useLingui = useLingui(),
      i18n = _useLingui.i18n;

  var locale = i18n.locale;
  var title = item.title,
      date = item.date,
      category = item.category,
      slug = item.slug,
      thumbnail = item.thumbnail,
      id = item.id;

  var _useContext = useContext(likesContext),
      allLikes = _useContext.allLikes,
      hasLikes = _useContext.hasLikes,
      checkLikes = _useContext.checkLikes,
      updateLikes = _useContext.updateLikes;

  useEffect(function () {
    checkLikes(id);
  }, []);
  var cateColor;

  switch (category) {
    case 'dev':
    case '開発':
      cateColor = 'green';
      break;

    case 'soccer':
    case 'サッカー':
      cateColor = 'red';
      break;

    case 'test':
    case 'テスト':
      cateColor = 'gray';
      break;

    case 'random':
    case 'ランダム':
      cateColor = 'blue';
      break;

    default:
      break;
  }

  var url;

  switch (place) {
    case 'recommended-blog':
      url = "./blog/" + slug;
      break;

    case 'blogs-page':
      url = "/" + locale + "/blog/" + slug;
      break;

    case 'blog-page':
      url = "/" + locale + "/blog/" + slug;
      break;

    default:
      break;
  }

  if (!url) {
    throw new Error('No place found');
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card__image-wrapper"
  }, /*#__PURE__*/React.createElement(Link, {
    to: url
  }, /*#__PURE__*/React.createElement(Image, {
    fluid: thumbnail,
    alt: title
  }))), /*#__PURE__*/React.createElement("div", {
    className: "card__text-wrapper"
  }, /*#__PURE__*/React.createElement("span", {
    className: "card__category " + (cateColor && cateColor)
  }, category), /*#__PURE__*/React.createElement("span", {
    className: "card__date"
  }, date), /*#__PURE__*/React.createElement("h3", {
    className: "card__title"
  }, title.length > 20 ? title.substring(0, 20) + ".." : title), /*#__PURE__*/React.createElement("div", {
    className: "card__likes-wrapper"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return !hasLikes[id] ? updateLikes(id, 'inc') : updateLikes(id, 'dec');
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    width: 20,
    height: 20,
    id: "icon-heart",
    color: hasLikes[id] ? 'rgb(255, 69, 58)' : 'rgba(255, 69, 58, .5)'
  })), /*#__PURE__*/React.createElement("span", null, allLikes[id]))));
};

export default Card;